import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { NativeModal } from '@dhl/native-modal'

import { Button } from '@dhl-ui/components'
import type { AgreedPlaceInterventionPreferenceWithPhoto } from '~/profile/model/preferences/model.js'
import { AgreedPlaceForm, type AgreedPlaceFormValues } from './AgreedPlaceForm.js'

type Props = {
  agreedPlace: AgreedPlaceInterventionPreferenceWithPhoto | null
  onChange: (values: AgreedPlaceFormValues) => void
  open: boolean
  onClose?: () => void
  buttonText?: string
}

export const AgreedPlaceDialog: FC<Props> = ({ agreedPlace, onClose, onChange, open, buttonText }) => {
  const { t } = useTranslation()

  const handleChange = (values: AgreedPlaceFormValues) => {
    onChange(values)
    onClose?.()
  }

  return (
    <NativeModal data-testid="agreed-place-dialog" open={open} onClose={onClose}>
      <NativeModal.Header title={t('portal.preferences.agreedPlace.dialogTitleText')} onClose={onClose} />
      <NativeModal.Content>
        <AgreedPlaceForm agreedPlace={agreedPlace} formId="agreed-place-form" onChange={handleChange} />
      </NativeModal.Content>
      <NativeModal.Footer>
        <Button fullWidth data-testid="submit-description" form="agreed-place-form" variant="contained" type="submit">
          {buttonText ?? t('portal.preferences.agreedPlace.saveButtonText')}
        </Button>
      </NativeModal.Footer>
    </NativeModal>
  )
}
